import { useState } from 'react';
import { AvatarWithLabel, Box, Chip, Menu, Popover, Typography, pxToRem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { markdownToReact } from 'app/domains/common-ui/Chat';
import { PromptContainer } from './styled';
export function PromptItem(props) {
    const { id, name, content, labels, onClick } = props;
    const [hover, setHover] = useState(false);
    const handleClick = () => {
        onClick(id);
    };
    const handleMouseOver = () => setHover(true);
    const handleMouseOut = () => setHover(false);
    const noOp = () => { };
    return (<Popover open={hover} onClose={handleMouseOut} placement="left-start" shadow="300" target={<div onFocus={noOp} onBlur={noOp} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
          <Menu.Item onClick={handleClick}>{name}</Menu.Item>
        </div>}>
      <Box flexDirection="column" gap="md" width={pxToRem(480)}>
        <AvatarWithLabel size="md" appearance="light" title={name}>
          <Falcon icon="eye"/>
        </AvatarWithLabel>

        <PromptContainer>
          <Typography $fontSize="small" $fontWeight="regular" $color="text.100">
            {markdownToReact({ markdown: content })}
          </Typography>
        </PromptContainer>

        {labels.length > 0 && (<Box gap="sm" style={{ flexWrap: 'wrap' }}>
            {labels.map((label) => (<Chip key={label} label={label}/>))}
          </Box>)}
      </Box>
    </Popover>);
}
